import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../blog/blogPosts";
import MainLayout from "../layouts/MainLayout";

export default function BlogListPage() {
  return (
    <MainLayout>
      <div className="container mx-auto p-6 bg-[#FFFBEB] min-h-screen text-[#111827]">
        <h1 className="text-4xl font-extrabold text-center mb-10 text-[#C994FF]">
          Insights from SassyPack
        </h1>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <div
              key={post.slug}
              className="card bg-[#FFFFFF] border border-[#E5E5E5] shadow-lg hover:shadow-xl transition-all rounded-2xl p-6"
            >
              <h2 className="text-2xl font-semibold text-[#C994FF] mb-2">
                {post.title}
              </h2>
              <p className="text-sm text-[#111827]/60 mb-4">
                {new Date(post.date).toLocaleDateString()}
              </p>
              <p className="text-[#111827]/80 mb-6 line-clamp-3">
                {post.description}
              </p>
              <Link
                to={`/blog/${post.slug}`}
                className="btn btn-sm bg-[#C994FF] text-[#000000] hover:bg-[#B074E0] rounded-full"
              >
                Read More →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
